import React, { useEffect, useState } from "react";
import CcList from "../ccList";
import CcHeaderVideo from "../ccHeaderVideo";
import CcLoader from "../ccLoader";
import TagPlaceholder from "../ccTagPlaceholder";
import eventBus from "../../../../helpers/eventBus";

export const Video = ({ items, defaultScreen, draftId }) => {
  const [videoItems, setVideoItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setVideoItems([]);
    const promises = [];
    
    items.forEach((item) => {
      let apiUrl = null;
      if(item.video.videoTag.length > 0) {
        if (defaultScreen?.template) {
          promises.push({ tag: item.video.videoTag });
          return;
        }
        if (!draftId) return;
        apiUrl = `tag/${item.video.videoTag}/${draftId}`;
      }
      if (item.video.videoUrl.length > 0) {
        apiUrl = `video/${item.video.videoUrl.split("/").pop()}`;
      }
      if (item.video.vimeoPlaylistId.length > 0) {
        apiUrl = `album/${item.video.vimeoPlaylistId}`;
      }
      if (!apiUrl) return;
      
      promises.push(
        fetch(`/api/public/vimeo/${apiUrl}`)
          .then((raw) => {
            if (raw.ok) return raw.json();
            const tag = item.video.videoTag;
            eventBus.publish("video:tag", { tag: tag, msg: `No video tagged with ${tag} found in subscriber showcase. When ${tag} will be added to any video in subscriber showcase it will show in conversion center without any updates`});
          })
          .catch((error) => console.error(error))
      );
    });
    
    if (promises.length === 0) {
      setLoading(false);
    }
    
    Promise.allSettled(promises)
      .then((results) => {
        return results.forEach((result) => {
          if (result.status !== "fulfilled") return;
          let items = [];
          if (result.value?.video) {
            items = [result.value.video.table];
          }
          if (result.value?.videos) {
            items = [...result.value.videos.table.all_videos.map((video) => video.table)];
          }
          if (result.value?.tag) {
            items = [result.value];
          }
          setVideoItems((prevState) => [
            ...prevState,
            ...items,
          ]);
          setLoading(false);
        });
      })
      .catch((error) => console.error(error));
    return () => {
      setVideoItems([]);
    }
  }, []);

  return(
    <>
      {loading && !videoItems.length && <CcLoader />}
      {!loading && videoItems.length === 0 && (
        <p style={{ textAlign: "center", margin: 10 }}>No video added</p>
      )}
      {
        videoItems.length > 0 && (
          <CcList fullwidth={false}>
            {videoItems.map((item) => {
              if (defaultScreen?.template && item?.tag) {
                return (
                  <TagPlaceholder key={item.tag} tag={item.tag} />
                );
              }
              return (
                <CcHeaderVideo
                  key={`${item.speciality}_${item.name}`}
                  type={item.video?.type}
                  src={item.video?.link}
                  poster={item.preview_image_url}
                  name={item.name}
                />
              );
            })}
          </CcList>
        )
      }
    </>
    
  );
};
